import React, { Fragment, useLayoutEffect } from "react";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/Help-Desk-Components/Footer/Footer";
import FeaturesSection from "./Features";
import HeaderBuga from "../../components/header6/Header6";
import { useLocation } from "react-router-dom";

const AboutUsPage = (props) => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <HeaderBuga />
        <section
          className="page-title pt-120 pos-rel bg_img breadcrums-bgr"
          //   style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <h2 className="title">About Us</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="about-video pt-75">
          <div className="container">
            <div className="career_video">
              {/* <img src={officeIMG} alt="" /> */}
              {/* <source src={Video} type="video/mp4" />
                Your browser does not support the video tag. */}
            </div>
          </div>
        </div>
        <div className="sd-ser-content_wrap pt-30 pb-110">
          <div className="container">
            <div className="sd-ser-content">
              <h2 className="sd-title">We are Buga Money</h2>
              <p className="sd-content fs-5">
                At Buga Money, we make sending money to your loved ones simple,
                secure, and stress-free. Whether you're supporting family,
                paying tuition, or covering medical expenses, our platform
                ensures fast and reliable money transfers from the UK to Nigeria
                and beyond.
              </p>
              <br />
              <p className="sd-content fs-5">
                With a strong focus on the UK–Nigeria corridor, Buga Money is
                built for trust and transparency. Enjoy competitive exchange
                rates, low fees, and real-time tracking — all backed by
                industry-leading security that keeps your funds safe every step
                of the way.
              </p>
              <br />
              <p className="sd-content fs-5">
                We believe sending money should be simple. Our user-friendly
                interface, helpful customer support, and flexible payment
                options make it easy for anyone to send funds with confidence —
                no matter the reason or destination.
              </p>
              <br />
              <p className="sd-content fs-5">
                Join the thousands of individuals and families who count on Buga
                Money for fast, safe, and affordable remittances. Send money the
                smart way — send it with Buga Money.
              </p>
            </div>
          </div>
        </div>

        <FeaturesSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutUsPage;
